module.exports = __webpack_public_path__ + "static/media/026-file-sharing-1.0e447ca9.svg";